import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { getErrorMessage } from '@enums/errorText';
import { environment } from '@home/src/app/environments/environment';

@Component({
  selector: 'app-error-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './app-error-page.component.html',
  styleUrl: './app-error-page.component.css',
})
export class ErrorPageComponent implements OnInit {
  @Input() statusCode: number = 0;
  error!: { title: string; message: string };
  redirectLoginUrl: string = '';

  ngOnInit() {
    this.error = getErrorMessage(this.statusCode);
    this.redirectLoginUrl = environment.redirectGroupUrl;
  }

  getErrorImage(): string {
    return `/assets/images/${this.statusCode || 500}.svg`;
  }
}
